export default "__VITE_ASSET__Bx4Ud6mF__"